export default "__VITE_ASSET__236b3bc9__"